import { gql } from "@apollo/client";

export const GET_SCHDULES_LIMIT = gql`
  query schedules($limit: Int, $start: Int, $sort: String) {
    schedules(limit: $limit, start: $start, sort: $sort) {
      id
      schedule_text
      schedule_date
    }
  }
`;

export const GET_SCHEDULE_BY_MONTH = gql`
  query schedules($where: JSON, $sort: String, $limit: Int, $start: Int) {
    schedules(where: $where, sort: $sort, limit: $limit, start: $start) {
      id
      schedule_text
      schedule_date
    }
  }
`;

export const GET_SCHEDULE_NEXT_PREV = gql`
  query schedules($where: JSON, $sort: String, $limit: Int) {
    schedules(where: $where, sort: $sort, limit: $limit) {
      id
      schedule_text
      schedule_date
    }
  }
`;

export const GET_SCHEDULES_COUNT = gql`
  query schedulesCount {
    schedulesCount
  }
`;
